import highProfile1 from './../assets/highProfile1.jpg'
import highProfile2 from './../assets/highProfile2.jpg'
import highProfile3 from './../assets/highProfile3.jpg'
import highProfile4 from './../assets/highProfile4.jpg'
const highLights = {
    highLightTitle: "Highlights of Defence Partnership Days 2024",
    preScheduleMeeting: "600 Participants   2200 Pre-scheduled Meetings",
    highProfile: {
        title: "High Profile Inauguration",
        profileData: {
            profile1: {
                name: "Gen Anil Chauhan, PVSM, UYSM, AVSM, SM, VSM Chief of Defence Staff", designation: "Chief of Defence Staff", image: highProfile1,
            },
            profile2: {
                name: "Sh Sanjeev Kumar, IAS", designation: "Secretary Defence Production", image: highProfile3,
            },
            profile3: {
                name: "Release of KPMG-IMR Knowledge Paper on Session", designation: "Doing Business in Defence", image: highProfile4,
            },
            profile4: {
                name: "The august gathering at the Inaugural ", image: highProfile2,
            },
        },
    },
    spoExhibitors: "13 Sponsors   51 Exhibitors",
    endlessNetwork: "Endless Networking",
};
export default highLights;